import React from "react";
import classNames from "classnames";
import { SocialNetwork, QRType } from "@/types/qr";
import { PreviewSocialNetworks } from "../PreviewSocialNetworks";
import { InitPreviewSocialLogos } from "../InitPreviewSocialLogos";
import { CSS_CLASSES } from "./constants";
import "./PreviewSocialSection.scss";

export interface PreviewSocialSectionProps {
  networks?: SocialNetwork[];
  variant: "business" | "coupon" | "links" | "website" | "mp3";
  type: QRType;
  isInitialPreview?: boolean;
  themeColor?: {
    buttonColor?: string;
    backgroundColor?: string;
  };
  className?: string;
}

/**
 * Consolidated social section for preview templates.
 * Renders real social networks or placeholders based on preview state and data availability.
 */
export function PreviewSocialSection({
  networks,
  variant,
  type,
  isInitialPreview = false,
  themeColor,
  className,
}: PreviewSocialSectionProps) {
  const hasNetworks = Boolean(networks && networks.length > 0);
  const shouldShowPlaceholders = Boolean(isInitialPreview && !hasNetworks);
  const shouldRender = Boolean(hasNetworks || isInitialPreview);

  if (!shouldRender) {
    return null;
  }

  const containerClasses = classNames(
    CSS_CLASSES.BASE,
    `${CSS_CLASSES.BASE}--${variant}`,
    {
      [CSS_CLASSES.INITIAL_STATE]: shouldShowPlaceholders,
      [CSS_CLASSES.NETWORKS_STATE]: hasNetworks,
    },
    className
  );

  return (
    <div className={containerClasses}>
      {shouldShowPlaceholders ? (
        <InitPreviewSocialLogos
          type={type}
          themeColor={themeColor}
          className={CSS_CLASSES.PLACEHOLDER}
        />
      ) : hasNetworks ? (
        <PreviewSocialNetworks
          networks={networks}
          variant={variant}
          className={CSS_CLASSES.NETWORKS}
        />
      ) : null}
    </div>
  );
}
